module.exports = __webpack_public_path__ + "static/media/evil-friends.105fb782.jpg";